import React, { Component } from "react";
import { connect } from "dva";
import Container from "../../../../../../components/Container";
import DailyStatisticList from "../List";
import {
  getBureauDailyList,
  getSchoolDailyList
} from "../../../../../../services/activitySign/dataStatistic/dailyStatistic";
import styles from "./index.less";

@connect(({ user }) => ({
  ...user
}))
class DailyDetailList extends Component {
  render() {
    const { currentUser } = this.props;
    const { orgType } = currentUser;
    const listProps = {
      isDetail: true,
      request: orgType === "school" ? getSchoolDailyList : getBureauDailyList
    };
    const containerProps = {
      breStates: 1,
      isPathParams: true,
      defaultPadding: 1
    };
    return (
      <Container {...containerProps}>
        <div className={styles.root}>
          <DailyStatisticList {...listProps} />
        </div>
      </Container>
    );
  }
}

export default DailyDetailList;
